import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Permissions } from '@app/modules/authentication/store/auth';
import { UserContextService } from '@app/modules/core/services/user-context.service';

interface HeaderNavItem {
  id: string;
  label: string;
  iconPath: string;
  route: string;
}

@Component({
    selector: 'topo-communications-header-bar',
    templateUrl: './communications-header-bar.component.html',
    styleUrls: ['./communications-header-bar.component.scss'],
    standalone: false
})
export class CommunicationsHeaderBar {
  private userContext = inject(UserContextService);
  private router = inject(Router);

  protected readonly headerNavItems = computed<HeaderNavItem[]>(() => {
    const userContext = this.userContext.getContext();
    const commsRoutes: Array<HeaderNavItem> = [];

    if (userContext?.hasPermission(Permissions.CommunicationNotificationRead)) {
      commsRoutes.push({
        id: 'communications_notifications',
        label: 'COMMUNICATIONS.TAB-NOTIFICATIONS',
        route: '/communications/notifications',
        iconPath: 'icon-bullhorn'
      });
    }

    if (userContext?.hasPermission(Permissions.ChannelConfigRead)) {
      commsRoutes.push({
        id: 'communications_channels',
        label: 'COMMUNICATIONS.TAB-CHANNELS',
        route: '/communications/channels',
        iconPath: 'icon-satellite-dish'
      });
    }

    if (userContext?.hasPermission(Permissions.DistributionListRead)) {
      commsRoutes.push({
        id: 'communications_distribution-lists',
        label: 'COMMUNICATIONS.TAB-DISTRIBUTION-LISTS',
        route: '/communications/distribution-lists',
        iconPath: 'icon-people-group'
      });
    }

    if (userContext?.hasPermission(Permissions.CommunicationTemplateRead)) {
      commsRoutes.push({
        id: 'communications_templates',
        label: 'COMMUNICATIONS.TAB-TEMPLATES',
        route: '/communications/templates',
        iconPath: 'icon-template'
      });
    }

    if (userContext?.hasPermission(Permissions.WorkflowRead)) {
      commsRoutes.push({
        id: 'communications_workflows',
        label: 'MANAGEMENT.WORKFLOW.WORKFLOW-TEMPLATES',
        route: '/communications/workflows',
        iconPath: 'icon-small_workflow'
      });
    }

    return commsRoutes;
  });

  navigate(path: string) {
    this.router.navigate([path]);
  }
}
